import { Status } from '../../../common/constants';

const PageHighlightConst = {
  statusesAvailToSet: [Status.Draft, Status.Live],
};

export default PageHighlightConst;
